/* eslint indent: 0 */

import './media_library.folder_zone.less';

import each from 'lodash/forEach';
import throttle from 'lodash/throttle';
import find from 'lodash/find';
import isNil from 'lodash/isNil';
import without from 'lodash/without';
import includes from 'lodash/includes';

import Backbone from 'backbone';

import Breadcrumbs from './media_library.breadcrumbs.js';
import FolderItem from './media_library.folder_item.js';
import AssetItem from './media_library.asset_item.js';

import folderZoneTemplate from './media_library.folder_zone.tpl';

import ESQuery from 'zoomforth_zf/models/es_query.js';
import MediaLibraryAsset from 'zoomforth_media_library/models/media_library_asset.js';

import { escapeForRegex } from 'zoomforth_zfutils/escaping.js';
import { makeFormModal } from 'zoomforth_tools/make_form_modal.js';

import navStateToESQuery from '../lib/nav_state_to_es_query.js';

import userStore from 'zoomforth_zf/appglobals/user.js';


const FolderZone = Backbone.View.extend({
    
    className: 'media-library-folder-zone no-breadcrumbs',
    
    events: {
      'click .file-items': 'clearSelection',
      'click .breadcrumbs-wrapper': 'clearSelection',
      'click .header-item': 'sortByHeaderClicked'
    },
        
    initialize: function(options) {
      this.parentView = options.parent;
      this.currentFolder = options.currentFolder;
      this.disallowedFolderIds = this.currentFolder.collection.getDisallowedFolderIdsForUser(
        { userModel: userStore.get() }
      );
      this.navState = options.navState;
      this.uploadTracker = options.uploadTracker;
      this.expandedAsset = false;
      
      
      this.removed = false;
      
      this.folderViews = [];
      this.assetViews = [];
      this.breadcrumbs = null; 
      
      this.selectedItems = [];
      
      this.folders = [];
      
      if(!this.navState.getIsSearching()) {
        this.listenTo(this.collection, 'add', this.folderAdded);
      }
      
      if(this.uploadTracker){
        this.listenTo(this.uploadTracker,{
          'upload-submitted': function(uploadData){
            uploadData.precursor.set('folder_id', this.currentFolder.get('id'));
            this.addUploadProgressView(uploadData.progressView);
          },
          'upload-complete': function(uploadData, assetModel){
            if(
              uploadData.precursor.get('folder_id') == this.currentFolder.get('id') &&
              includes(this.navState.enabledMediaTypes, uploadData.precursor.get('assetType'))
            ){
              this.addAssetFromModel(assetModel, uploadData.progressView);

            } else {
              // if the new asset is not in the enabled types of media and not
              // in the same folder then we need to clean up the progress view.
              uploadData.progressView.remove();

            }
          }
        });
      }
    },
    
    render: function() {
      var me = this;
      me.$el.html(folderZoneTemplate({
        assetDisplayState: this.navState.get('asset_display_type'),
        navState: this.navState,
        isPrivateFolder: !!(
          !me.navState.getIsSearching() && 
          includes(this.disallowedFolderIds, this.currentFolder.get('id'))
        )
      }));
      if(me.parentView.getCallingContext() != 'view_only') {
        me.renderBreadcrumbs();
      }

      if (!me.navState.getIsSearching()) {
        if(me.uploadTracker){
          each(me.uploadTracker.getUploadsInFolder(me.currentFolder.get('id')), function(upload){
            me.addUploadProgressView(upload.progressView); 
          });
        }
      }
      if (!me.navState.getIsSearchingByMediaTypes()) {
        // A folder never matches a "media type" search
        me.renderFolders();
      }
      me.renderAssets();
      me.$('.file-items-wrapper').bind('scroll', this.throttledLoadThumbnails.bind(this));

      return me;
    },
    
    renderBreadcrumbs: function() {
      var me = this;
      var frag = $(document.createDocumentFragment()); 
      me._removeBreadcrumbs();
      me.breadcrumbs = new Breadcrumbs({
        currentFolder: me.currentFolder,
        navState: this.navState
      }); 
      me._bindBreadcrumbListeners(me.breadcrumbs);
      frag.append(me.breadcrumbs.render().$el);
      me.$('.breadcrumbs-wrapper').append(frag);
      me.$el.removeClass('no-breadcrumbs');
    }, 
    
    _addFolder: function(folderModel){
      var folderView = new FolderItem({
        model: folderModel,
        allowDragging: !this.parentView.getIsSelectionContext(),
        assetDisplayState: this.navState.get('asset_display_type')
      });
      this.folderViews.push(folderView);
      this._bindFolderListeners(folderView);
      folderView.render();
      return folderView;
    },
    
    renderFolders: function() {
      var me = this;
      var frag = $(document.createDocumentFragment());
      me._removeFolderViews();
      me.folders = me.currentFolder.getChildren();
      if(this.navState.getTextSearch()) {
        me.folders = me.filterFolderCollection();
      }
      if(this.navState.get('sort_by')) {
        me.sortFolders();
      } 
      this.putSpecialFoldersFirst();
      each(me.folders, function(folderModel) {
        var folderView = me._addFolder(folderModel);
        frag.append(folderView.$el);
      });
      me.$('.files-not-yet-loaded-message').before(frag);
    },
    
    putSpecialFoldersFirst: function() {
      var me = this; 
      var index;
      var specialFolders = me.folders.filter(function(model) {
        return (
          model.get('special_folder_type') == 'prompts' || 
          model.get('special_folder_type') == 'uploads'
        );
      });  
      specialFolders.sort(function(a,b) { return a.get('name') < b.get('name'); });
      each(specialFolders, function(folderModel) {
        index = me.folders.indexOf(folderModel); 
        if(index > -1) {
          me.folders.splice(index, 1); 
        }
        me.folders.unshift(folderModel); 
      });
    }, 
    
    /**
     * @TODO: 
     * `created_at` and `last_modified_at` seem to be string timestamps,
     * so these objects should be refactored to use moment objects.
     * 
     * That being said, ISO8601 timestamps ARE sortable as strings,
     * and since we're not comparing different timezones there is no real concern here.
     */
    sortTypeToComparisonMap: {
      'date_added': function(a, b) {
        if(a.get('created_at') > b.get('created_at')) {
          return -1;
        } else if(a.get('created_at') < b.get('created_at')) {
          return 1;
        } else {
          return 0;
        }
      },
      'date_modified': function(a, b) {
        var aDate = a.get('last_modified_at'); 
        var bDate = b.get('last_modified_at'); 
        if((aDate > bDate) || (bDate == null && aDate != null)) {
          return -1;
        } else if((aDate < bDate) || (aDate == null && bDate != null)) {
          return 1;
        } else {
          return 0;
        }
      },
      'display_filename': function(a, b) {
        if(a.get('name') < b.get('name')) {
          return -1;
        } else if(a.get('name') > b.get('name')) {
          return 1;
        } else {
          return 0; 
        }
      }
    },
    
    sortFolders: function() {
      var sortField;
      var me = this;
      if(this.navState.get('sort_by')) {
        sortField = this.navState.get('sort_by').split(':')[0];
        me.folders.sort(me.sortTypeToComparisonMap[sortField]); 
      }
    }, 
    
    filterFolderCollection: function() {
      var filteredFolders; 
      var escapedQuery = escapeForRegex(this.navState.getTextSearch().toLowerCase()); 
      var re = RegExp('.*'+escapedQuery+'.*');

      var currentFolderId = this.navState.get('folder_id');

      filteredFolders = this.collection.filter(function(folder) {
        if (!isNil(currentFolderId) && currentFolderId !== folder.get('parent_id')) {
          return false;
        }

        return !!(folder.get('name').toLowerCase().match(re));
      });

      return filteredFolders;
    }, 
    
    renderAssets: function() {
      this._removeAssetViews();
      const esQuery = new ESQuery(navStateToESQuery(this.navState));
      this._bindESQueryListener(esQuery);
      esQuery.getNextPage();
    }, 
    
    folderAdded: function(folderModel){
      if (folderModel.get('parent_id') == this.currentFolder.get('id')){
        var folderView = this._addFolder(folderModel);
        this.$('.file-items').prepend(folderView.$el);
        this._applyEmptyFolderStatus();
      }
    },
    
    _prependItem: function($item){
      var $lastFolder = this.$('.media-library-folder').last();
      if($lastFolder.length){
        $item.insertAfter($lastFolder);
      } else{
        this.$('.file-items').prepend($item);
      }
      this._applyEmptyFolderStatus();
    },
    
    addUploadProgressView: function(uploadView){
      this._prependItem(uploadView.$el);
      uploadView.render();
      uploadView.el.scrollIntoView({ behavior: 'smooth' });
    },
    
    addAssetFromModel: function(newAssetModel, replaceView){
      
      var assetView = this._addAsset(newAssetModel);
      
      if(replaceView){
        replaceView.$el.replaceWith(assetView.$el);
        replaceView.remove();
      } else{
        this._prependItem(assetView.$el);
        assetView.$el.hide().fadeIn();
      }
      
      this._applyEmptyFolderStatus();

      return assetView;
    },
    
    _addAsset: function(assetModel){
      var assetView;
      var assetViewOptions = {
        model: assetModel,
        allowDragging: !this.parentView.getIsSelectionContext() && !this.navState.getIsSearching(),
        dragHelperFn: this.itemDragHelper.bind(this),
        showSelectionOverlay: this.parentView.getIsSelectionContext(),
        assetDisplayState: this.navState.get('asset_display_type')
      };
      assetView = new AssetItem(assetViewOptions);
      this.assetViews.push(assetView);
      this._bindAssetListeners(assetView);
      assetView.render();
      return assetView;
    },
    
    _applyEmptyFolderStatus: function(){
      if(this.$('.media-library-item').length){
        this.$('.empty-folder-message').hide();
      } else{
        this.$('.empty-folder-message').show();
      }
    },
    
    _bindESQueryListener: function(ESQueryModel) {
      var me = this;

      this.listenTo(ESQueryModel, {
        /*
          every time the 'page-loaded' event fires, it adds all of the models from
          the search query into the folder zone
        */
        'page-loaded': function(response) {
          var currentAssetViewsIndex = this.assetViews.length;
          var frag = $(document.createDocumentFragment());
          each(response.results, function(assetJson) {
            // @TODO eventually this should be handled on the backend.
            // see comment in `getDisallowedFolderIdsForUser`
            if (includes(me.disallowedFolderIds, assetJson.parent_folder_id)) {
              // do not add assets from disallowed folders into the view
              return;
            }
            var assetModel = new MediaLibraryAsset(assetJson, {parse: true});
            var assetView = me._addAsset(assetModel);
            frag.append(assetView.$el);
          });
          me.$('.files-not-yet-loaded-message').before(frag);
          me._loadThumbnails(me.assetViews.slice(currentAssetViewsIndex));
          if(!me.removed){
            ESQueryModel.getNextPage();
          }
        },
        'finished': function(){
          me.$('.files-not-yet-loaded-message').hide();
          me._applyEmptyFolderStatus();
        }
      });
    },
    
    _bindBreadcrumbListeners: function(breadcrumbsView) {
      this.listenTo(breadcrumbsView, {
        'navigate': function(folderModel) {
          this.clearSelection();
          this.navState.navigate({
            folder_id:folderModel.get('id')
          });
        }
      });
    },
    
    _bindFolderListeners: function(folderView){
      var me = this;
      
      if (this.parentView.getIsSelectionContext()){
        this.listenTo(folderView, {
          'dblclick': function(folderModel){
            me.clearSelection();
            this.navState.navigateToFolderId(folderModel.get('id'));
          }
        });
      } else{
        this.listenTo(folderView, {
          'click': function(){
            me._giveExclusiveFocus(folderView);
          },
          'dblclick': function(folderModel){
            me.navState.navigateToFolderId(folderModel.get('id'));
          },
          'return-pressed': this._renameItem,
          'removed': this._applyEmptyFolderStatus,
          'dropped-on': function(draggable){
            var itemView;
            if(me._itemIsSelected(draggable)){
              each(me.selectedItems, function(selectedItem){
                selectedItem.model.moveToFolder(folderView.model.get('id'));
              });
            } else{
              itemView = this._getItemView(draggable);
              itemView.model.moveToFolder(folderView.model.get('id'));
            }
          }
        });
        
        folderView.listenTo(folderView.model, 'change:parent_id', function(){
          folderView.fadeOut();
          
        });
      }
    },
    
    _bindAssetListeners: function(assetView) {
      var me = this;
      
      var toggleAsset = function(){
        if(this._folderIsSelected()){
          return;
        }
        if(assetView.$el.hasClass('selected')){
          this._deselectItemView(assetView);
        } else {
          this._selectItem(assetView.$el);
        }
        if(this.selectedItems.length == 1){
          this.selectedItems[0].$el.focus();
        } else{
          $(document.activeElement).blur();
        }
        this.trigger('items-selected', this.selectedItems);
      };
      
      var extendSelection = function(){
        if(this.shiftSelectItems(assetView)){
          $(document.activeElement).blur();
          this.trigger('items-selected', this.selectedItems);
        }
      };
      
      var toggleExpandedAsset = function(assetModel) {
        if(this.assetExpanded) {
          me.trigger('close-expanded-asset', assetModel);
          this.assetExpanded = false;
        } else {
          me.trigger('expand-asset', assetModel);
          this.assetExpanded = true;
        }
      };
      
      var expandAsset = function(assetModel) {
        this.assetExpanded = true;
        me.trigger('expand-asset', assetModel); 
      };  
      
      var listenToDict = {
        'dblclick': expandAsset,
        'click': function(){
          me._giveExclusiveFocus(assetView);
        },
        'shift-click': extendSelection,
        'command-click': toggleAsset
      };
      
      if (this.parentView.getIsSelectionContext()){
        listenToDict['click'] = toggleAsset;
        listenToDict['expand'] = expandAsset;
      } else{
        listenToDict['return-pressed'] = this._renameItem;
        listenToDict['space-pressed'] = toggleExpandedAsset;
        listenToDict['removed'] = this._applyEmptyFolderStatus;
        
        assetView.listenTo(assetView.model, 'change:parent_folder_id', function(){
          if(!me.navState.getIsSearching()){
            assetView.fadeOut();
          }
        });
      }
      
      this.listenTo(assetView, listenToDict);
    },
    
    _renameItem: function(itemModel){
      makeFormModal({
        title: 'Edit Title',
        highlight: true,
        inputs: [{
          key: 'Title',
          name: 'new_name',
          value: itemModel.getName()
        }]
      }).done(function(form) {
        itemModel.rename(form.new_name);
      });
    },
    
    _giveExclusiveFocus: function(itemView){
      this._deselectItems();
      this._selectItem(itemView.$el);
      itemView.$el.focus();
      this.trigger('items-selected', this.selectedItems);
    },

    remove: function() {
      this._removeFolderViews();
      this._removeAssetViews();
      this._removeBreadcrumbs();
      this.removed = true;
      FolderZone.__super__.remove.call(this);
    },
    
    _removeBreadcrumbs: function() {
      if(this.breadcrumbs) {
        this.breadcrumbs.remove();
      }
    }, 

    _removeAssetViews: function() {
      each(this.assetViews, function(assetView) {
        assetView.remove();
      });
      this.assetViews = [];
    }, 
    
    _removeFolderViews: function() {
      each(this.folderViews, function(folderView) {
        folderView.remove();
      });
      this.folderViews = [];
    },
    
    throttledLoadThumbnails: throttle(function(){
      this._loadThumbnails();
    }, 60),
    
    _loadThumbnails: function(assetViews){
      if(!assetViews){
        assetViews = this.assetViews;
      }
      each(assetViews, function(assetView){
        assetView.loadThumbnail();
      });
    },
    
    clearSelection: function(){
      this._deselectItems();
      this.trigger('items-selected', this.selectedItems);
    },
    
    _deselectItems: function(){
      this.selectedItems = [];
      this.$('.file-items .selected').removeClass('selected');
    },
    
    _folderIsSelected: function(){
      for (var i=0; i < this.selectedItems.length; i++) {
        if(!(this.selectedItems[i].model instanceof MediaLibraryAsset)){
          return true;
        }
      }
      return false;
    },
    
    _itemIsSelected: function($item){
      return !!find(this.selectedItems, function(itemView){
        return itemView.$el.is($item);
      });
    },
    
    _getItemView: function($item){
      var itemView = find(this.assetViews, function(assetView){
        return assetView.$el.is($item);
      });
      if(!itemView){
        itemView = find(this.folderViews, function(folderView){
          return folderView.$el.is($item);
        });
      }
      return itemView;
    },
    
    _selectItem: function($item){
      var itemView = this._getItemView($item);      
      itemView.$el.addClass('selected');
      this.selectedItems.push(itemView);
      itemView.helperFn = this.itemDragHelper.bind(this);
    },
    
    _deselectItemView: function(itemView){
      this.selectedItems = without(this.selectedItems, itemView);
      itemView.$el.removeClass('selected');
    },
    
    shiftSelectItems: function(itemView){
      var $targetAssets;
      var $asset = itemView.$el;
      if($asset.hasClass('selected')){
        this._deselectItemView(itemView);
        return false;
      }
      // shift clicking should only work for assets,
      // if a folder is selected, abort
      if(this.selectedItems.length && !this._folderIsSelected()){
        if($asset.prevAll('.selected').length){
          $targetAssets = $asset.prevUntil('.selected');
        } else {
          $targetAssets = $asset.nextUntil('.selected');
        }
        each($targetAssets, this._selectItem.bind(this));
        this._selectItem($asset);
        return true;
      }
      return false;
    },
    
    itemDragHelper: function(e, ui){
      /// this needs to return the element that should be 
      // dragged when a selected element is dragged.
      // it should not need to be explicitly unbound
      var $current = $(e.currentTarget);
      if(this.selectedItems.length == 1 || !this._itemIsSelected($current)){
        return $current.clone();
      }
      return $('<div class="multiple-drag-items">'+this.selectedItems.length+'</div>');
    },

    sortByHeaderClicked: function(e){
      var targetSortMethod = $(e.currentTarget).attr('data-sort-type');
      var currentSortMethod = this.navState.get('sort_by');

      if (typeof currentSortMethod == 'undefined' || typeof targetSortMethod == 'undefined') {
        return;
      }

      // determine the current sort being applied to the list
      var currentSortSplit = currentSortMethod.split(':');
      var currentSortValue = currentSortSplit[0];
      var currentSortDirection = currentSortSplit[1];

      // determine the target sorting we want to do
      var targetSortSplit = targetSortMethod.split(':');
      var targetSortValue = targetSortSplit[0];

      // If the current sort and target sort are working on the same field then
      // we want to use the opposite direction. Otherwise we can sort on the
      // new method and direction they are trying to do.
      var sortMethod = targetSortMethod;
      if (currentSortValue === targetSortValue) {
        var direction = (currentSortDirection == 'asc') ? 'desc' : 'asc';
        sortMethod = currentSortValue + ':' + direction;
      }

      this.navState.navigate({
        sort_by: sortMethod
      });
    }
    
  });
  

export default FolderZone;
